import { Skeleton, Stack} from "@mui/material"
import { BoxPanel } from "screens/styles";

export const QuestionSingleSkeleton = () => {
  return (
    <BoxPanel className="BoxShadow">
      <Stack gap={6}>
        <Stack direction={'row'} justifyContent='space-between' alignItems={'center'}>
          <Stack gap={2} width={'100%'}>
            <Skeleton variant='text' sx={{borderRadius:8, width:'32%', backgroundColor:'#E9ECF5'}}/>
            <Skeleton variant='text' sx={{borderRadius:8, width:'64%', backgroundColor:'#E9ECF5'}}/>
          </Stack>
          <Skeleton variant='rectangular' sx={{borderRadius:8,  width:'17%', height:33, backgroundColor:'#E9ECF5'}}/>
        </Stack>
          <Stack direction={'row'} gap={6}>
            <Stack className="BoxShadow" sx={{flexBasis:'30%', alignItems:'center', gap:2, paddingX:1, paddingY:2.2}}>
              <Skeleton variant='rectangular' sx={{borderRadius:8, width:'77%', backgroundColor:'#E9ECF5'}}/>
              <Skeleton variant='rectangular' sx={{borderRadius:8, width:'100%', backgroundColor:'#E9ECF5'}}/>
            </Stack>
            <Stack className="BoxShadow" sx={{flexBasis:'30%', alignItems:'center', gap:2, paddingX:1, paddingY:2.2}}>
              <Skeleton variant='rectangular' sx={{borderRadius:8, width:'77%', height:16, backgroundColor:'#E9ECF5'}}/>
              <Skeleton variant='rectangular' sx={{borderRadius:8, width:'100%', height:16, backgroundColor:'#E9ECF5'}}/>
            </Stack>
            <Stack className="BoxShadow" sx={{flexBasis:'30%', alignItems:'center', gap:2, paddingX:1, paddingY:2.2}}>
              <Skeleton variant='rectangular' sx={{borderRadius:8, width:'77%', height:16, backgroundColor:'#E9ECF5'}}/>
              <Skeleton variant='rectangular' sx={{borderRadius:8, width:'100%', height:16, backgroundColor:'#E9ECF5'}}/>
            </Stack>
        </Stack>
      </Stack>
    </BoxPanel>
  )
}
